import { render, staticRenderFns } from "./LegalFormSelect.vue?vue&type=template&id=2222d5f2&"
import script from "./LegalFormSelect.vue?vue&type=script&lang=js&"
export * from "./LegalFormSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports